@if (totalPages > 1) {
  <nav aria-label="Pagination">
    <ul>
      @if (selectedPage > 3) {
        <li>
          <button
            [attr.aria-disabled]="selectedPage === 1"
            [disabled]="selectedPage === 1"
            (click)="onFirstPage()"
          >
            <i class="fa fa-angle-double-left" aria-hidden="true"></i>
          </button>
        </li>
      }
      @if (selectedPage > 2) {
        <li>
          <button
            [attr.aria-disabled]="selectedPage === 1"
            [disabled]="selectedPage === 1"
            (click)="onPrevious()"
          >
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
        </li>
      }
      @for (page of visiblePages; track page) {
        <li>
          <a
            class="internal"
            [class.current]="page === selectedPage"
            [attr.aria-current]="page === selectedPage ? 'page' : null"
            [attr.aria-label]="
              page === selectedPage
                ? 'Current Page, Page ' + page
                : 'Go to Page ' + page
            "
            tabindex="0"
            (click)="onPageClick(page)"
            (keyup.enter)="onPageClick(page)"
            >{{ page }}</a
          >
        </li>
      }
      @if (selectedPage < totalPages - 1) {
        <li>
          <button
            [attr.aria-disabled]="selectedPage === totalPages"
            [disabled]="selectedPage === totalPages"
            (click)="onNext()"
          >
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </li>
      }
      @if (selectedPage < totalPages - 2) {
        <li>
          <button
            [attr.aria-disabled]="selectedPage === totalPages"
            [disabled]="selectedPage === totalPages"
            (click)="onLastPage()"
          >
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </button>
        </li>
      }
    </ul>
  </nav>
}
